import { render } from "./Table4Charts.vue?vue&type=template&id=d784281a&scoped=true"
import script from "./Table4Charts.vue?vue&type=script&lang=js"
export * from "./Table4Charts.vue?vue&type=script&lang=js"

import "./Table4Charts.vue?vue&type=style&index=0&id=d784281a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d784281a"]])

export default __exports__